import { getSuggestionsApiCall } from '../api/suggestion.api';
import { onFailure, onSuccess, setLoading } from '../store/suggestion.store';

/*----- DECLARE THUNKS ------*/
export const getSuggestions = (id: string, searchTerms = '', catalog = 'UNIFIED') => (dispatch: Function) => {
  dispatch(setLoading(id));

  getSuggestionsApiCall(searchTerms, catalog)
    .then(suggestions => suggestions ? dispatch(onSuccess({id, suggestions})) : dispatch(onFailure(id)))
    .catch(() => dispatch(onFailure(id)));
};
